import { message as Message } from '@tencent/spaui';
import _ from 'lodash';

export const genMsgFun = (type) => (msg = '', options = {}) => {
  if (!_.includes(['success', 'warn', 'strongwarn', 'error', 'info', 'loading'], type)) {
    return;
  }
  Message[type]({
    duration: 3,
    theme: 'light',
    ...options,
    message: msg,
  });
};

const message = {
  success: genMsgFun('success'),
  warn: genMsgFun('warn'),
  strongwarn: genMsgFun('strongwarn'),
  error: genMsgFun('error'),
  info: genMsgFun('info'),
  loading: genMsgFun('loading'),
};

export default message;
